import { FC, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { Spin } from 'antd';

import camera from 'assets/icons/camera.svg';

import styles from './index.module.scss';

type PrimaryMarketPhotoItemProps = {
	src: string;
	isFirst?: boolean;
	isLittle?: boolean;
	isOne?: boolean;
	isSecond?: boolean;
	isButton?: boolean;
	isModal?: boolean;
	index?: any;
	isCarousel?: boolean;
};
export const PrimaryMarketPhotoItem: FC<PrimaryMarketPhotoItemProps> = ({
	src,
	isLittle,
	isFirst,
	isOne,
	isSecond,
	isButton,
	index,
	isCarousel,
	isModal,
}) => {
	const ref = useRef(index);
	const imageClassName = classNames([styles.image], {
		[styles.first]: isFirst && !isOne,
		[styles.one]: isOne,
		[styles.second]: isSecond,
		[styles.little]: isLittle,
		[styles.button]: isButton,
		[styles.modal]: isModal,
	});

	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (ref.current && !ref.current.complete) {
			setLoading(true);
		}
	}, [index]);

	return (
		<>
			{loading && isCarousel && (
				<div className={styles.spinner}>
					<Spin size="large" />
				</div>
			)}
			<img
				ref={ref}
				loading="eager"
				onLoad={() => {
					setLoading(false);
				}}
				className={imageClassName}
				src={src}
				alt="src"
				onError={({ currentTarget }) => {
					currentTarget.onerror = null;
					currentTarget.className = `${currentTarget.className} primaryItemImages__image_error`;
					currentTarget.src = camera;
				}}
			/>
		</>
	);
};
